import * as React from 'react';

function SvgIconSwitchOn(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 45 25"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path id="icon-switch-on_svg__a" d="M.8.769H25V24H.8z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M7.787 20.5C3.487 20.5 0 17.142 0 13c0-4.142 3.486-7.5 7.787-7.5h22.425C34.514 5.5 38 8.858 38 13c0 4.142-3.486 7.5-7.788 7.5H7.787z"
          fillOpacity={0.5}
          fill="#4B1C46"
        />
        <g transform="translate(19 .5)">
          <mask id="icon-switch-on_svg__b" fill="#fff">
            <use xlinkHref="#icon-switch-on_svg__a" />
          </mask>
          <path
            d="M25 12.384C25 18.8 19.583 24 12.9 24 6.218 24 .8 18.8.8 12.384.8 5.97 6.219.768 12.9.768c6.683 0 12.1 5.2 12.1 11.616"
            fill="#4B1C46"
            mask="url(#icon-switch-on_svg__b)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgIconSwitchOn;
